import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageHeader, Alert, Icon } from '../ui';

const PendingApprovalPage = () => {
    const { user, logout } = useAuth();

    return (
        <div className="ui-page" style={{ maxWidth: 760 }}>
            <PageHeader title="Очікує схвалення" />
            <Alert kind="warn">
                Обліковий запис <b>{user?.email}</b> створено і він чекає на схвалення адміністратора.
                Доступ до цін конкурентів і каталогу з'явиться одразу після підтвердження.
            </Alert>
            <div className="ui-toolbar">
                <Link to="/dashboard" className="ui-btn ui-btn--primary">
                    <Icon name="overview" /> На огляд
                </Link>
                <button onClick={logout} className="ui-btn">
                    <Icon name="logout" /> Вийти
                </button>
            </div>
        </div>
    );
};

export default PendingApprovalPage;
